import React, { useState, useRef, useEffect } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import PDFOverlay from './PDFOverlay';

const PDFViewer = ({
  loading,
  error,
  pdfUrl,
  isDarkMode,
  currentTableData,
  currentSelection,
  currentPage,
  setCurrentPage,
  defaultLayoutPluginInstance,
  pageNavigationPluginInstance
}) => {
  const viewerContainerRef = useRef(null);
  const [pageLayer, setPageLayer] = useState(null);

  useEffect(() => {
    const updatePageLayer = () => {
        if (viewerContainerRef.current) {
          const layer = viewerContainerRef.current.querySelector(`[data-testid="core__page-layer-${currentPage}"]`);
        //   console.log('Looking for page layer:', {
        //     currentPage,
        //     found: !!layer,
        //     layer
        //   });
          if (layer) {
            setPageLayer(layer);
          }
        }
    };

  updatePageLayer();

    // Set up an interval to check periodically
    const interval = setInterval(updatePageLayer, 100);

    // Check on scroll
    const container = viewerContainerRef.current;
    if (container) {
      container.addEventListener('scroll', updatePageLayer);
    }

    return () => {
      clearInterval(interval);
      if (container) {
        container.removeEventListener('scroll', updatePageLayer);
      }
    };
  }, [currentPage, viewerContainerRef.current]);



  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="flex items-center justify-center h-full text-red-500">
          {error}
        </div>
      );
    }

    if (!pdfUrl) {
      return (
        <div className={`flex items-center justify-center h-full ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
          No PDF selected
        </div>
      );
    }

    return (
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <div className="h-full relative">
          <Viewer
            fileUrl={pdfUrl}
            plugins={[defaultLayoutPluginInstance, pageNavigationPluginInstance]}
            defaultScale={1.0}
            onPageChange={(e) => setCurrentPage(e.currentPage)}
            theme={isDarkMode ? 'dark' : 'light'}
          />
          {currentTableData && currentSelection?.selectedCells?.length > 0 && (
            <PDFOverlay
            selectedCells={currentSelection.selectedCells}
            textractMetadata={currentTableData.textractMetadata}
            pageNumber={currentTableData.pageNumber}
            currentPage={currentPage}
            viewerContainer={pageLayer}
            />
          )}
        </div>
      </Worker>
    );
  };

  return (
    <div className="h-full relative" ref={viewerContainerRef}>
      {renderContent()}
    </div>
  );
};

export default PDFViewer;